const generateInterventionGroupValues = (referenceMap) => {
    let partOfRelationshipReference = {
        "reference": "Composition/" + referenceMap.compositionId,
        "type": "Composition",
        "display": referenceMap.compositionTitle
    };
    if (referenceMap?.populationReference && referenceMap.interventionDescriptionReference) {
        return {
            "combinationMethod": "all-of",
            "characteristic": [
                {
                    "description": "inclusion in " + referenceMap.populationReference.display,
                    "code": { "text": "Member of" },
                    "valueReference": referenceMap.populationReference,
                    "exclude": false
                },
                {
                    "description": "exposed to " + referenceMap.interventionDescriptionReference.display,
                    "code": { "text": "Exposed to" },
                    "valueReference": referenceMap.interventionDescriptionReference,
                    "exclude": false
                }
            ],
            "partOfRelationshipReference": partOfRelationshipReference
        };
    } else if (referenceMap?.populationReference) {
        return {
            "combinationMethod": "all-of",
            "characteristic": [
                {
                    "description": "inclusion in " + referenceMap.populationReference.display,
                    "code": { "text": "Member of" },
                    "valueReference": referenceMap.populationReference,
                    "exclude": false
                },
                {
                    "description": "exposed to the intervention",
                    "code": { "text": "Exposed to" },
                    "valueCodeableConcept": { "text": "the intervention" },
                    "exclude": false
                }
            ],
            "partOfRelationshipReference": partOfRelationshipReference
        };
    }
};

export default generateInterventionGroupValues;